const ACTION_TYPES = {
    RESET_EMAIL_STATE: 'RESET_EMAIL_STATE',
    SET_PERSONALIZED_MESSAGE: 'SET_PERSONALIZED_MESSAGE',
    SET_RECIPIENT_EMAILS: 'SET_RECIPIENT_EMAILS',
    SET_SENDER_EMAIL: 'SET_SENDER_EMAIL',
    SET_SENDER_NAME: 'SET_SENDER_NAME',
    SET_SHOW_NOTES: 'SET_SHOW_NOTES',
};

function resetEmailState() {
    return { type: ACTION_TYPES.RESET_EMAIL_STATE };
}

function setPersonalizedMessage({ personalizedMessage }) {
    return { type: ACTION_TYPES.SET_PERSONALIZED_MESSAGE, personalizedMessage };
}

function setRecipientEmails({ recipientEmails }) {
    return { type: ACTION_TYPES.SET_RECIPIENT_EMAILS, recipientEmails };
}

function setSenderEmail({ senderEmail }) {
    return { type: ACTION_TYPES.SET_SENDER_EMAIL, senderEmail };
}

function setSenderName({ senderName }) {
    return { type: ACTION_TYPES.SET_SENDER_NAME, senderName };
}

function setShowNotes({ showNotes }) {
    return { type: ACTION_TYPES.SET_SHOW_NOTES, showNotes };
}

export default {
    ...ACTION_TYPES,
    resetEmailState,
    setPersonalizedMessage,
    setRecipientEmails,
    setSenderEmail,
    setSenderName,
    setShowNotes,
};
